import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, take, takeUntil } from 'rxjs';
import { AutoProffService } from '../../../auto-proff/auto-proff.service';
import { ProductPageService } from '../../../page/product-page/product-page.service';

@Component({
    selector: 'ncg-get-price-button',
    standalone: true,
    template: `
        <ng-container *ngIf="productPageService.productPageData$ | async as productPageData">
            <button *ngIf="show" type="button" [ngClass]="buttonClass" (click)="openPriceService()">
                {{ hasPriceService ? productPageData.getPriceButtonText : productPageData.getPriceButtonErrorText }}
            </button>
        </ng-container>
    `,
    imports: [CommonModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GetPriceButtonComponent implements OnDestroy {
    private readonly unsubscribe = new Subject<void>();

    public hasPriceService = true;
    public show = false;

    @Input()
    public buttonClass?: string;

    // Remove from rendering flow
    @HostBinding('style')
    public get style() {
        if (!this.show) {
            return {
                display: 'none',
            };
        }
    }

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly autoProffService: AutoProffService,
        public readonly productPageService: ProductPageService
    ) {
        this.productPageService.productPageData$
            .pipe(take(1), takeUntil(this.unsubscribe))
            .subscribe(({ isGetPriceButtonEnabled = true, getPriceButtonText, getPriceButtonErrorText }) => {
                this.show = Boolean(isGetPriceButtonEnabled && getPriceButtonText && getPriceButtonErrorText);
                this.cd.markForCheck();
                this.autoProffService.init().catch((e) => {
                    console.warn(`Tried to intialize AutoProff in GetPriceButton. Failed with error: "${e}"`);
                });
            });
    }

    public ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public openPriceService(): void {
        this.hasPriceService = this.autoProffService.openPopup();
        this.cd.markForCheck();
    }
}
